import React from "react";
import "../../App.css";
import { useTranslation } from "react-i18next";
import "./Fiat.css";

function Fiat() {
	const { t } = useTranslation();
	return (
		<div className="resources-container">
			<h1 className="resource">{t("Bitcoin-temp-message")}</h1>
		</div>
	);
}
export default Fiat;
